// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --manage-installer-bannder-height: 244px;
    --manage-installer-bannder-search-group-height: 142px;
    --manage-installer-search-btn-width: 133px;
    --manage-installer-search-btn-height: 56px;
}

.manage-installer-header-start-section {
    min-height: var(--manage-installer-bannder-height);
    background: var(--bg-blue) 0% 0% no-repeat padding-box;
    color: var(--neutral-color1);
    width: 100%;
}

.wrapper-manage-installer-header-section {
    width: 100%;
    min-height: var(--manage-installer-bannder-height);
    padding: var(--body-header-padding);
    transition: all 0.5s;
}

.wrapper-manage-installer-header-section .manage-installer-header-search-group-section {
    display: grid;
    grid-template-columns: 0.5fr 2fr 0.5fr;
}

.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) {
    display: grid;
    grid-template-columns: 1fr 0.26fr;
    grid-column-gap: 8px;
}

.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item {
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px var(--border-shadow-color3);
    min-height: var(--manage-installer-bannder-search-group-height);
    border-radius: 6px;
    padding: 18px 32px 20px;
    display: grid;
    grid-row-gap: 15px;
}

.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2) {
    max-width: 150px;
    cursor: pointer;
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--call-to-action1);
    padding: 24px;
    display: grid;
    align-items: center;
    justify-items: center;
    grid-row-gap: 0;
    text-align: center;
}

.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2):hover {
    transform: scale(1.02);
    color: var(--call-to-action2);
}

.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2):hover svg path:not(:nth-child(1)) {
    fill: var(--call-to-action2);
    transition: all 0.5s;

}

.manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:first-child {
    font: normal normal 300 26px/32px Lato;
    letter-spacing: 0.26px;
    color: var(--neutral-color7);
}

.manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:nth-child(2) {
    display: grid;
    grid-template-columns: 1fr 0.4fr;
    grid-column-gap: 15px;
}

.manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:nth-child(2) .search-group-item-section:first-child input {
    font-weight: bold;
    color: var(--neutral-color7);
}

.manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:nth-child(2) .search-group-item-section:first-child label {
    letter-spacing: 0px;
    color: var(--neutral-color6);
     font-size: 14px;
}

.manage-installer-search-group-btn {
    min-width: var(--manage-installer-search-btn-width);
    height: var(--manage-installer-search-btn-height);
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.manage-installer-search-group-btn svg {
    margin-right: 10px;
}

.manage-installer-search-group-btn:hover {
    background-color: var(--call-to-action2);
}


.wrapper-manage-installer-body-content-section {
    width: 100%;
    height: 100%;
    display: grid;
    grid-row-gap: 8px;
    transition: all 1s;
}

.mutedaddinstallerbtn {
    /* background-color: var(--call-to-action3); */
    background-color: #A6D5EA !important;
    /*  */
}

/* ------------ Manage Installer Card -------------- */
.manage-installer-card-section {
    min-height: 62px;
    width: 100%;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    padding: 9px 14px 9px 24px;
    border: 1px solid transparent;
    transition: all 0.5s;
}

.manage-installer-card-section:hover {
    transform: scale(1.012);
    transition: all 0.5s;
    border: 1px solid var(--call-to-action1);
}

.wrapper-manage-installer-card-section {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 5fr 1.5fr;
    grid-column-gap: 20px;
    align-items: center;
    transition: all 0.5s;
}

.manage-installer-card-section.sidebar-active .wrapper-manage-installer-card-section {
    grid-template-columns: 1fr 4fr 1.5fr;
    transition: all 0.5s;
}

.wrapper-manage-installer-card-section .normal-card-item-section {
    height: 100%;
    display: grid;
    align-items: center;
}

.wrapper-manage-installer-card-section .normal-card-item-section:first-child {
    border-right: 1px solid var(--neutral-color3);
}

.wrapper-manage-installer-card-section .normal-card-item-section:first-child .card-item-value {
    font: normal normal bold 18px/22px Lato;
    letter-spacing: 0.18px;
    color: var(--call-to-action1);
    cursor: pointer;
}

.wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 20px;
    border-right: 1px solid var(--neutral-color3);
    cursor: pointer;
}


.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section {
    transition: all 1s;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 5px;
    /* padding: 5px; */
}

.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-btn-section {
    min-height: 35px;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 18px;
    font: normal normal bold 14px/17px Lato;
    letter-spacing: 0.14px;
    color: var(--neutral-color1);
    text-transform: capitalize;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.5s;
    animation: fadeIn1 0.5s auto;
    margin-top: auto;
    margin-bottom: auto;
}


.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-btn-section svg {
    margin-right: 5px;
}

.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-btn-section:hover {
    background-color: var(--call-to-action2);
}

.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section:first-child {
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border: 1px solid var(--call-to-action1);
    color: var(--call-to-action1);
}

.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section:first-child:hover {
    border: 1px solid var(--call-to-action2);
    color: var(--call-to-action2);
    transition: var(--normal-transition);
}

.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section:first-child svg {
    width: 11px;
    height: 15px;
}

.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section:first-child:hover svg path {
    fill: var(--call-to-action2);
    transition: var(--normal-transition);
}

/* ----------- Manage Installer Card -------------- */
.wrapper-manage-installer-body-content-section.custom-card {
    grid-template-columns: repeat(auto-fill, minmax(318px, 1fr));
    grid-column-gap: 10px;
}

.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section {
    grid-template-columns: 1fr;
    grid-row-gap: 10px;
}

.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(1) {
    padding: 10px 0;
    border-right: transparent;
    border-bottom: 1px solid var(--neutral-color4);
}

.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {
    grid-template-columns: 1fr;
    row-gap: 10px;
    padding-bottom: 10px;
    border-right: transparent;
    border-bottom: 1px solid var(--neutral-color4);
}

.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(1) .card-item-group,
.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) .card-item-group {
    display: grid;
    grid-template-columns: 0.8fr 1fr;
}

.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(3) {
    padding: 5px 0;
}

.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section {
    min-height: 50px;
    border-radius: 26px;
}

/* ------------------ Modal ----------------- */
/* ----------- Installer Details Modal -------------- */
.installer-details-modal .modal-dialog {
    max-width: 60%;
    margin-top: 8%;
}

.installer-details-modal .modal-dialog .modal-content {
    min-height: 30vh;
    padding: 0 51px;
}

.installer-details-modal .modal-dialog .wrapper-modal-header {
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--neutral-color4);
}

.installer-details-modal .modal-header-title-section {
    display: flex;
    width: 100%;
    align-items: center;
}

.installer-details-modal .modal-header-title-section span {
    margin-left: 15px;
    font: normal normal 300 28px/34px Lato;
    letter-spacing: 0.28px;
    color: var(--neutral-color5);
}

.installer-details-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font: normal normal bold 14px/19px Lato;
    letter-spacing: 0.14px;
    color: var(--text-color2);
}

.installer-details-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {
    margin-right: 10px;
}

.installer-details-modal .modal-body {
    max-height: 300px;
    padding-top: 20px;
}

.modal-body .wrapper-modal-body {
    width: 100%;
    height: 100%;
    display: grid;
    grid-row-gap: 15px;
}

.installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group {
    display: grid;
    grid-row-gap: 30px;
    padding-bottom: 30px;
}

.installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group .installer-details-modal-card-item-inner-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 40px;
}


.installer-details-modal .modal-body .wrapper-modal-body .revart-back-modal-card-item-group {
    grid-template-columns: 1fr;
}

/* ------------------ Add Installer ------------------ */

.installer-data-manage-modal .modal-dialog {
    max-width: 70%;
    margin-top: 8%;
}

#addInstallerModal .modal-dialog {
    margin-top: 2%;
}

.installer-data-manage-modal .modal-dialog .modal-content {
    min-height: 30vh;
    padding: 0 51px;
}

.installer-data-manage-modal .modal-dialog .wrapper-modal-header {
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--neutral-color4);
}


.installer-data-manage-modal .modal-body {
    max-height: 400px;
    padding-top: 2px;
    padding-bottom: 15px;
}

.installer-data-manage-modal .modal-body .wrapper-modal-body {
    grid-row-gap: 20px;
}

.installer-data-manage-modal .modal-body .wrapper-modal-body .mobal-body-section-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 15px;
}

#editInstallerModal .modal-body .wrapper-modal-body .mobal-body-section-group:first-child {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 15px;
}

/* ------------------ Delete Installer ------------------ */
.delete-installer-details-modal .modal-dialog {
    max-width: 60%;
    margin-top: 3%;
}

.delete-installer-details-modal .modal-dialog .modal-content {
    min-height: 30vh;
    padding: 0 51px;
}

.delete-installer-details-modal .modal-dialog .wrapper-modal-header {
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--neutral-color4);
}

.delete-installer-details-modal .modal-header-title-section {
    display: grid;
    width: 100%;
    align-items: center;
    justify-items: center;
    grid-template-columns: 1fr;
    grid-row-gap: 5px;
}

.delete-installer-details-modal .modal-dialog .modal-content .modal-header-title-section .modal-header-title-item:nth-child(2) {
    font: normal normal bold 22px/27px Lato !important;
    letter-spacing: 0.22px;
}

.delete-installer-details-modal .modal-dialog .modal-content .modal-header-title-section .modal-header-title-item:last-child {
    font: normal normal normal 18px/22px Lato;
    letter-spacing: 0.18px;
}

.delete-installer-details-modal .modal-body {
    padding-top: 10px;
    margin-top: 0;
}

.delete-installer-details-modal .modal-body .wrapper-modal-body {
    width: 100%;
    height: 100%;
    display: grid;
    row-gap: 20px;
    grid-template-rows: repeat(2, 1fr);
}


.delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:first-child {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 10px;
    column-gap: 30px;
}



.delete-installer-details-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font: normal normal bold 14px/19px Lato;
    letter-spacing: 0.14px;
    color: var(--text-color2);
}

.delete-installer-details-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {
    margin-right: 10px;
}



.delete-installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group {
    display: grid;
    grid-row-gap: 30px;
    padding-bottom: 30px;
}

.delete-installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group .installer-details-modal-card-item-inner-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10px;
}


.delete-installer-details-modal .modal-body .wrapper-modal-body .revart-back-modal-card-item-group {
    grid-template-columns: 1fr;
}


.manage-installer-confirmation-section .workorder-confirmation-content-section {
    grid-row-gap: 20px;
}

.manage-installer-confirmation-section .workorder-confirmation-content-section .wrapper-workorder-confirmation-content-section .confirmation-content-item:last-child {
    color: var(--neutral-color7) !important;
}

.manage-installer-confirmation-section .confirmation-back-btn-section {
    padding: 0 15px;
}

.addinstallerspan {
    color: var(--indicators-red);
}

@media screen and (max-width:1280px) {
    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section.sidebar-active {
        grid-template-columns: 0fr 2fr 0fr;
    }

    .manage-installer-card-section.sidebar-active .wrapper-manage-installer-card-section {
        grid-template-columns: 1fr 2fr 1fr;
    }

    .manage-installer-card-section.sidebar-active .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {
        grid-template-columns: repeat(2, 1fr);
    }
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    :root {
        --manage-installer-bannder-height: 320px;
        --manage-installer-bannder-search-group-height: 142px;
        --manage-installer-search-btn-width: 133px;
        --manage-installer-search-btn-height: 56px;
    }

    #addInstallerModal {
        padding-left: 0 !important;
    }

    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section,
    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) {
        grid-template-columns: 1fr;
    }

    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) {
        grid-row-gap: 20px;
    }

    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item {
        padding: 0;
        box-shadow: none;
        background-color: transparent;
        grid-row-gap: 10px;
    }

    .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:first-child {
        font: normal normal 300 18px/22px Lato;
        letter-spacing: 0.18px;
        color: var(--neutral-color1);
    }

    .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:nth-child(2) {
        grid-template-columns: 1fr;
        grid-row-gap: 24px;
    }

    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2) {
        max-width: 100%;
        min-height: 56px;
        width: 100%;
        padding: 0;
        display: flex;
        justify-content: center;
        background: var(--neutral-color1) 0% 0% no-repeat padding-box;
        border: 1px solid var(--call-to-action1);
        border-radius: 26px;
    }

    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2) span {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2):hover {
        border-color: var(--call-to-action2);
        transition: all 0.5s;
    }

    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2) svg {
        height: 19px;
    }

    /* ------- Card ------- */
    .manage-installer-card-section {
        min-height: auto;
    }

    .wrapper-manage-installer-card-section,
    .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
        border-right: transparent;
    }

    .wrapper-manage-installer-card-section .normal-card-item-section {
        padding: 10px 0;
    }

    .wrapper-manage-installer-card-section .normal-card-item-section:first-child,
    .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {
        border-bottom: 1px solid var(--neutral-color4);
        border-right: transparent;
    }

    .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {
        padding-bottom: 20px;
    }

    .wrapper-manage-installer-card-section .normal-card-item-section:first-child .card-item-group,
    .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) .card-item-group {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        grid-column-gap: 10px;
    }

    .wrapper-manage-installer-card-section .normal-card-item-section:last-child {
        padding: 0;
        padding-top: 10px;
    }

    .wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section {
        height: 50px;
    }

    .wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section {
        height: 100%;
        border-radius: 26px;
    }

    /* ----------- Modal ---------- */
    .installer-details-modal .modal-dialog .modal-header {
        padding: 0 21px;
    }

    .installer-details-modal .modal-dialog .modal-content,
    .installer-data-manage-modal .modal-dialog .modal-content,
    .delete-installer-details-modal .modal-dialog .modal-content {
        padding: 0;
        min-height: auto;
    }

    .installer-details-modal .modal-dialog .modal-content {
        height: auto;
        position: absolute;
        bottom: 0;
    }

    .installer-data-manage-modal .modal-dialog .wrapper-modal-header,
    .delete-installer-details-modal .modal-dialog .modal-content .wrapper-modal-header,
    .delete-installer-details-modal .modal-body {
        padding: 29px 21px 0;
        border-bottom: 0;
    }

    .installer-data-manage-modal .modal-dialog .wrapper-modal-header .modal-header-title-section {
        padding-bottom: 10px;
        border-bottom: 1px solid var(--neutral-color4);
    }

    .installer-details-modal .modal-body,
    .installer-data-manage-modal .modal-body {
        height: 100%;
        max-height: 100%;
        padding: 10px var(--padding-left);
    }

    .installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group {
        grid-row-gap: 20px;
    }

    .installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group .installer-details-modal-card-item-inner-group {
        grid-template-columns: 1fr;
        grid-row-gap: 20px;
    }

    .installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group .installer-details-modal-card-item-inner-group .card-item-group {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        text-align: start;
        grid-column-gap: 10px;
    }

    .installer-data-manage-modal .modal-body .wrapper-modal-body .mobal-body-section-group,
    .delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:first-child {
        grid-template-columns: 1fr;
        grid-row-gap: 20px;
    }

    .installer-data-manage-modal .modal-footer,
    .delete-installer-details-modal .modal-footer {
        box-shadow: 1px -0px 8px var(--border-shadow-color5);
    }

    #editInstallerModal .modal-body .wrapper-modal-body .mobal-body-section-group:first-child {
        grid-template-columns: 1fr;
    }

    #editInstallerModal .modal-body .wrapper-modal-body .mobal-body-section-group:first-child .card-item-group,
    .delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:first-child .card-item-group {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        grid-column-gap: 10px;
        text-align: start;
    }

    .delete-installer-details-modal .modal-body {
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .delete-installer-details-modal .modal-header-title-section svg {
        width: 31px;
        height: 31px;
    }

    .delete-installer-details-modal .modal-dialog .modal-content .modal-header-title-section .modal-header-title-item:nth-child(2) {
        letter-spacing: 0.22px;
    }

    .delete-installer-details-modal .modal-dialog .modal-content .modal-header-title-section .modal-header-title-item:last-child {
        font: normal normal normal 16px/19px Lato;
        letter-spacing: 0.16px;
        text-align: center;
    }

    .delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:last-child .form-group,
    .delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:last-child .form-group textarea {
        min-height: 150px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/ManageInstallerPage.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,qDAAqD;IACrD,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA;IACI,kDAAkD;IAClD,sDAAsD;IACtD,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kDAAkD;IAClD,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,6DAA6D;IAC7D,mDAAmD;IACnD,+DAA+D;IAC/D,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;;AAExB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;KAC3B,eAAe;AACpB;;AAEA;IACI,mDAAmD;IACnD,iDAAiD;IACjD,8DAA8D;IAC9D,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;AAC5C;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,8CAA8C;IAC9C,oCAAoC;IACpC,KAAK;AACT;;AAEA,sDAAsD;AACtD;IACI,gBAAgB;IAChB,WAAW;IACX,6DAA6D;IAC7D,iCAAiC;IACjC,kBAAkB;IAClB,0BAA0B;IAC1B,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,6CAA6C;IAC7C,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,8DAA8D;IAC9D,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6DAA6D;IAC7D,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA,qDAAqD;AACrD;IACI,4DAA4D;IAC5D,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,oBAAoB;IACpB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;;IAEI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C,uDAAuD;AACvD;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;AACzB;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA,wDAAwD;;AAExD;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,8CAA8C;AAClD;;;AAGA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA,2DAA2D;AAC3D;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,kDAAkD;IAClD,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kCAAkC;AACtC;;;AAGA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,gBAAgB;AACpB;;;;AAIA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;;;AAIA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;AACzB;;;AAGA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA,wCAAwC;AACxC;IACI;QACI,wCAAwC;QACxC,qDAAqD;QACrD,0CAA0C;QAC1C,0CAA0C;IAC9C;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,6BAA6B;QAC7B,kBAAkB;IACtB;;IAEA;QACI,sCAAsC;QACtC,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,UAAU;QACV,aAAa;QACb,uBAAuB;QACvB,6DAA6D;QAC7D,wCAAwC;QACxC,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,oCAAoC;QACpC,oBAAoB;IACxB;;IAEA;QACI,YAAY;IAChB;;IAEA,yBAAyB;IACzB;QACI,gBAAgB;IACpB;;IAEA;;QAEI,0BAA0B;QAC1B,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,8CAA8C;QAC9C,yBAAyB;IAC7B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;QAEI,aAAa;QACb,gCAAgC;QAChC,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA,iCAAiC;IACjC;QACI,eAAe;IACnB;;IAEA;;;QAGI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,SAAS;IACb;;IAEA;;;QAGI,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;QACpB,8CAA8C;IAClD;;IAEA;;QAEI,YAAY;QACZ,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,gCAAgC;QAChC,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;;QAEI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;;QAEI,oDAAoD;IACxD;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,aAAa;QACb,gCAAgC;QAChC,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,yCAAyC;QACzC,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;;QAEI,iBAAiB;IACrB;AACJ","sourcesContent":[":root {\r\n    --manage-installer-bannder-height: 244px;\r\n    --manage-installer-bannder-search-group-height: 142px;\r\n    --manage-installer-search-btn-width: 133px;\r\n    --manage-installer-search-btn-height: 56px;\r\n}\r\n\r\n.manage-installer-header-start-section {\r\n    min-height: var(--manage-installer-bannder-height);\r\n    background: var(--bg-blue) 0% 0% no-repeat padding-box;\r\n    color: var(--neutral-color1);\r\n    width: 100%;\r\n}\r\n\r\n.wrapper-manage-installer-header-section {\r\n    width: 100%;\r\n    min-height: var(--manage-installer-bannder-height);\r\n    padding: var(--body-header-padding);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-manage-installer-header-section .manage-installer-header-search-group-section {\r\n    display: grid;\r\n    grid-template-columns: 0.5fr 2fr 0.5fr;\r\n}\r\n\r\n.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: 1fr 0.26fr;\r\n    grid-column-gap: 8px;\r\n}\r\n\r\n.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item {\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px var(--border-shadow-color3);\r\n    min-height: var(--manage-installer-bannder-search-group-height);\r\n    border-radius: 6px;\r\n    padding: 18px 32px 20px;\r\n    display: grid;\r\n    grid-row-gap: 15px;\r\n}\r\n\r\n.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2) {\r\n    max-width: 150px;\r\n    cursor: pointer;\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--call-to-action1);\r\n    padding: 24px;\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n    grid-row-gap: 0;\r\n    text-align: center;\r\n}\r\n\r\n.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2):hover {\r\n    transform: scale(1.02);\r\n    color: var(--call-to-action2);\r\n}\r\n\r\n.wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2):hover svg path:not(:nth-child(1)) {\r\n    fill: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n\r\n}\r\n\r\n.manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:first-child {\r\n    font: normal normal 300 26px/32px Lato;\r\n    letter-spacing: 0.26px;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: 1fr 0.4fr;\r\n    grid-column-gap: 15px;\r\n}\r\n\r\n.manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:nth-child(2) .search-group-item-section:first-child input {\r\n    font-weight: bold;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:nth-child(2) .search-group-item-section:first-child label {\r\n    letter-spacing: 0px;\r\n    color: var(--neutral-color6);\r\n     font-size: 14px;\r\n}\r\n\r\n.manage-installer-search-group-btn {\r\n    min-width: var(--manage-installer-search-btn-width);\r\n    height: var(--manage-installer-search-btn-height);\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 26px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.manage-installer-search-group-btn svg {\r\n    margin-right: 10px;\r\n}\r\n\r\n.manage-installer-search-group-btn:hover {\r\n    background-color: var(--call-to-action2);\r\n}\r\n\r\n\r\n.wrapper-manage-installer-body-content-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-row-gap: 8px;\r\n    transition: all 1s;\r\n}\r\n\r\n.mutedaddinstallerbtn {\r\n    /* background-color: var(--call-to-action3); */\r\n    background-color: #A6D5EA !important;\r\n    /*  */\r\n}\r\n\r\n/* ------------ Manage Installer Card -------------- */\r\n.manage-installer-card-section {\r\n    min-height: 62px;\r\n    width: 100%;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px #00000029;\r\n    border-radius: 6px;\r\n    padding: 9px 14px 9px 24px;\r\n    border: 1px solid transparent;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.manage-installer-card-section:hover {\r\n    transform: scale(1.012);\r\n    transition: all 0.5s;\r\n    border: 1px solid var(--call-to-action1);\r\n}\r\n\r\n.wrapper-manage-installer-card-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 5fr 1.5fr;\r\n    grid-column-gap: 20px;\r\n    align-items: center;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.manage-installer-card-section.sidebar-active .wrapper-manage-installer-card-section {\r\n    grid-template-columns: 1fr 4fr 1.5fr;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section {\r\n    height: 100%;\r\n    display: grid;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:first-child {\r\n    border-right: 1px solid var(--neutral-color3);\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:first-child .card-item-value {\r\n    font: normal normal bold 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n    color: var(--call-to-action1);\r\n    cursor: pointer;\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    column-gap: 20px;\r\n    border-right: 1px solid var(--neutral-color3);\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section {\r\n    transition: all 1s;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 5px;\r\n    /* padding: 5px; */\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-btn-section {\r\n    min-height: 35px;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 18px;\r\n    font: normal normal bold 14px/17px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--neutral-color1);\r\n    text-transform: capitalize;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n    animation: fadeIn1 0.5s auto;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-btn-section svg {\r\n    margin-right: 5px;\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-btn-section:hover {\r\n    background-color: var(--call-to-action2);\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section:first-child {\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border: 1px solid var(--call-to-action1);\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section:first-child:hover {\r\n    border: 1px solid var(--call-to-action2);\r\n    color: var(--call-to-action2);\r\n    transition: var(--normal-transition);\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section:first-child svg {\r\n    width: 11px;\r\n    height: 15px;\r\n}\r\n\r\n.wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section:first-child:hover svg path {\r\n    fill: var(--call-to-action2);\r\n    transition: var(--normal-transition);\r\n}\r\n\r\n/* ----------- Manage Installer Card -------------- */\r\n.wrapper-manage-installer-body-content-section.custom-card {\r\n    grid-template-columns: repeat(auto-fill, minmax(318px, 1fr));\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section {\r\n    grid-template-columns: 1fr;\r\n    grid-row-gap: 10px;\r\n}\r\n\r\n.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(1) {\r\n    padding: 10px 0;\r\n    border-right: transparent;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {\r\n    grid-template-columns: 1fr;\r\n    row-gap: 10px;\r\n    padding-bottom: 10px;\r\n    border-right: transparent;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(1) .card-item-group,\r\n.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) .card-item-group {\r\n    display: grid;\r\n    grid-template-columns: 0.8fr 1fr;\r\n}\r\n\r\n.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(3) {\r\n    padding: 5px 0;\r\n}\r\n\r\n.wrapper-manage-installer-body-content-section.custom-card .wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section {\r\n    min-height: 50px;\r\n    border-radius: 26px;\r\n}\r\n\r\n/* ------------------ Modal ----------------- */\r\n/* ----------- Installer Details Modal -------------- */\r\n.installer-details-modal .modal-dialog {\r\n    max-width: 60%;\r\n    margin-top: 8%;\r\n}\r\n\r\n.installer-details-modal .modal-dialog .modal-content {\r\n    min-height: 30vh;\r\n    padding: 0 51px;\r\n}\r\n\r\n.installer-details-modal .modal-dialog .wrapper-modal-header {\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.installer-details-modal .modal-header-title-section {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n}\r\n\r\n.installer-details-modal .modal-header-title-section span {\r\n    margin-left: 15px;\r\n    font: normal normal 300 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    color: var(--neutral-color5);\r\n}\r\n\r\n.installer-details-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    font: normal normal bold 14px/19px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--text-color2);\r\n}\r\n\r\n.installer-details-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {\r\n    margin-right: 10px;\r\n}\r\n\r\n.installer-details-modal .modal-body {\r\n    max-height: 300px;\r\n    padding-top: 20px;\r\n}\r\n\r\n.modal-body .wrapper-modal-body {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-row-gap: 15px;\r\n}\r\n\r\n.installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group {\r\n    display: grid;\r\n    grid-row-gap: 30px;\r\n    padding-bottom: 30px;\r\n}\r\n\r\n.installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group .installer-details-modal-card-item-inner-group {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-column-gap: 40px;\r\n}\r\n\r\n\r\n.installer-details-modal .modal-body .wrapper-modal-body .revart-back-modal-card-item-group {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n/* ------------------ Add Installer ------------------ */\r\n\r\n.installer-data-manage-modal .modal-dialog {\r\n    max-width: 70%;\r\n    margin-top: 8%;\r\n}\r\n\r\n#addInstallerModal .modal-dialog {\r\n    margin-top: 2%;\r\n}\r\n\r\n.installer-data-manage-modal .modal-dialog .modal-content {\r\n    min-height: 30vh;\r\n    padding: 0 51px;\r\n}\r\n\r\n.installer-data-manage-modal .modal-dialog .wrapper-modal-header {\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n\r\n.installer-data-manage-modal .modal-body {\r\n    max-height: 400px;\r\n    padding-top: 2px;\r\n    padding-bottom: 15px;\r\n}\r\n\r\n.installer-data-manage-modal .modal-body .wrapper-modal-body {\r\n    grid-row-gap: 20px;\r\n}\r\n\r\n.installer-data-manage-modal .modal-body .wrapper-modal-body .mobal-body-section-group {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    grid-column-gap: 15px;\r\n}\r\n\r\n#editInstallerModal .modal-body .wrapper-modal-body .mobal-body-section-group:first-child {\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-gap: 15px;\r\n}\r\n\r\n/* ------------------ Delete Installer ------------------ */\r\n.delete-installer-details-modal .modal-dialog {\r\n    max-width: 60%;\r\n    margin-top: 3%;\r\n}\r\n\r\n.delete-installer-details-modal .modal-dialog .modal-content {\r\n    min-height: 30vh;\r\n    padding: 0 51px;\r\n}\r\n\r\n.delete-installer-details-modal .modal-dialog .wrapper-modal-header {\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.delete-installer-details-modal .modal-header-title-section {\r\n    display: grid;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-items: center;\r\n    grid-template-columns: 1fr;\r\n    grid-row-gap: 5px;\r\n}\r\n\r\n.delete-installer-details-modal .modal-dialog .modal-content .modal-header-title-section .modal-header-title-item:nth-child(2) {\r\n    font: normal normal bold 22px/27px Lato !important;\r\n    letter-spacing: 0.22px;\r\n}\r\n\r\n.delete-installer-details-modal .modal-dialog .modal-content .modal-header-title-section .modal-header-title-item:last-child {\r\n    font: normal normal normal 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n}\r\n\r\n.delete-installer-details-modal .modal-body {\r\n    padding-top: 10px;\r\n    margin-top: 0;\r\n}\r\n\r\n.delete-installer-details-modal .modal-body .wrapper-modal-body {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    row-gap: 20px;\r\n    grid-template-rows: repeat(2, 1fr);\r\n}\r\n\r\n\r\n.delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:first-child {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-gap: 10px;\r\n    column-gap: 30px;\r\n}\r\n\r\n\r\n\r\n.delete-installer-details-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    font: normal normal bold 14px/19px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--text-color2);\r\n}\r\n\r\n.delete-installer-details-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {\r\n    margin-right: 10px;\r\n}\r\n\r\n\r\n\r\n.delete-installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group {\r\n    display: grid;\r\n    grid-row-gap: 30px;\r\n    padding-bottom: 30px;\r\n}\r\n\r\n.delete-installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group .installer-details-modal-card-item-inner-group {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n\r\n.delete-installer-details-modal .modal-body .wrapper-modal-body .revart-back-modal-card-item-group {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n\r\n.manage-installer-confirmation-section .workorder-confirmation-content-section {\r\n    grid-row-gap: 20px;\r\n}\r\n\r\n.manage-installer-confirmation-section .workorder-confirmation-content-section .wrapper-workorder-confirmation-content-section .confirmation-content-item:last-child {\r\n    color: var(--neutral-color7) !important;\r\n}\r\n\r\n.manage-installer-confirmation-section .confirmation-back-btn-section {\r\n    padding: 0 15px;\r\n}\r\n\r\n.addinstallerspan {\r\n    color: var(--indicators-red);\r\n}\r\n\r\n@media screen and (max-width:1280px) {\r\n    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section.sidebar-active {\r\n        grid-template-columns: 0fr 2fr 0fr;\r\n    }\r\n\r\n    .manage-installer-card-section.sidebar-active .wrapper-manage-installer-card-section {\r\n        grid-template-columns: 1fr 2fr 1fr;\r\n    }\r\n\r\n    .manage-installer-card-section.sidebar-active .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    :root {\r\n        --manage-installer-bannder-height: 320px;\r\n        --manage-installer-bannder-search-group-height: 142px;\r\n        --manage-installer-search-btn-width: 133px;\r\n        --manage-installer-search-btn-height: 56px;\r\n    }\r\n\r\n    #addInstallerModal {\r\n        padding-left: 0 !important;\r\n    }\r\n\r\n    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section,\r\n    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) {\r\n        grid-row-gap: 20px;\r\n    }\r\n\r\n    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item {\r\n        padding: 0;\r\n        box-shadow: none;\r\n        background-color: transparent;\r\n        grid-row-gap: 10px;\r\n    }\r\n\r\n    .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:first-child {\r\n        font: normal normal 300 18px/22px Lato;\r\n        letter-spacing: 0.18px;\r\n        color: var(--neutral-color1);\r\n    }\r\n\r\n    .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:first-child .manage-installer-search-group-item-row-section:nth-child(2) {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 24px;\r\n    }\r\n\r\n    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2) {\r\n        max-width: 100%;\r\n        min-height: 56px;\r\n        width: 100%;\r\n        padding: 0;\r\n        display: flex;\r\n        justify-content: center;\r\n        background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n        border: 1px solid var(--call-to-action1);\r\n        border-radius: 26px;\r\n    }\r\n\r\n    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2) span {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2):hover {\r\n        border-color: var(--call-to-action2);\r\n        transition: all 0.5s;\r\n    }\r\n\r\n    .wrapper-manage-installer-header-section .manage-installer-header-search-group-section .manage-installer-header-search-group-item-section:nth-child(2) .manage-installer-search-group-item:nth-child(2) svg {\r\n        height: 19px;\r\n    }\r\n\r\n    /* ------- Card ------- */\r\n    .manage-installer-card-section {\r\n        min-height: auto;\r\n    }\r\n\r\n    .wrapper-manage-installer-card-section,\r\n    .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n        border-right: transparent;\r\n    }\r\n\r\n    .wrapper-manage-installer-card-section .normal-card-item-section {\r\n        padding: 10px 0;\r\n    }\r\n\r\n    .wrapper-manage-installer-card-section .normal-card-item-section:first-child,\r\n    .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {\r\n        border-bottom: 1px solid var(--neutral-color4);\r\n        border-right: transparent;\r\n    }\r\n\r\n    .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) {\r\n        padding-bottom: 20px;\r\n    }\r\n\r\n    .wrapper-manage-installer-card-section .normal-card-item-section:first-child .card-item-group,\r\n    .wrapper-manage-installer-card-section .normal-card-item-section:nth-child(2) .card-item-group {\r\n        display: grid;\r\n        grid-template-columns: 0.5fr 1fr;\r\n        grid-column-gap: 10px;\r\n    }\r\n\r\n    .wrapper-manage-installer-card-section .normal-card-item-section:last-child {\r\n        padding: 0;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section {\r\n        height: 50px;\r\n    }\r\n\r\n    .wrapper-manage-installer-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section {\r\n        height: 100%;\r\n        border-radius: 26px;\r\n    }\r\n\r\n    /* ----------- Modal ---------- */\r\n    .installer-details-modal .modal-dialog .modal-header {\r\n        padding: 0 21px;\r\n    }\r\n\r\n    .installer-details-modal .modal-dialog .modal-content,\r\n    .installer-data-manage-modal .modal-dialog .modal-content,\r\n    .delete-installer-details-modal .modal-dialog .modal-content {\r\n        padding: 0;\r\n        min-height: auto;\r\n    }\r\n\r\n    .installer-details-modal .modal-dialog .modal-content {\r\n        height: auto;\r\n        position: absolute;\r\n        bottom: 0;\r\n    }\r\n\r\n    .installer-data-manage-modal .modal-dialog .wrapper-modal-header,\r\n    .delete-installer-details-modal .modal-dialog .modal-content .wrapper-modal-header,\r\n    .delete-installer-details-modal .modal-body {\r\n        padding: 29px 21px 0;\r\n        border-bottom: 0;\r\n    }\r\n\r\n    .installer-data-manage-modal .modal-dialog .wrapper-modal-header .modal-header-title-section {\r\n        padding-bottom: 10px;\r\n        border-bottom: 1px solid var(--neutral-color4);\r\n    }\r\n\r\n    .installer-details-modal .modal-body,\r\n    .installer-data-manage-modal .modal-body {\r\n        height: 100%;\r\n        max-height: 100%;\r\n        padding: 10px var(--padding-left);\r\n    }\r\n\r\n    .installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group {\r\n        grid-row-gap: 20px;\r\n    }\r\n\r\n    .installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group .installer-details-modal-card-item-inner-group {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 20px;\r\n    }\r\n\r\n    .installer-details-modal .modal-body .wrapper-modal-body .installer-details-modal-card-item-group .installer-details-modal-card-item-inner-group .card-item-group {\r\n        display: grid;\r\n        grid-template-columns: 0.5fr 1fr;\r\n        text-align: start;\r\n        grid-column-gap: 10px;\r\n    }\r\n\r\n    .installer-data-manage-modal .modal-body .wrapper-modal-body .mobal-body-section-group,\r\n    .delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:first-child {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 20px;\r\n    }\r\n\r\n    .installer-data-manage-modal .modal-footer,\r\n    .delete-installer-details-modal .modal-footer {\r\n        box-shadow: 1px -0px 8px var(--border-shadow-color5);\r\n    }\r\n\r\n    #editInstallerModal .modal-body .wrapper-modal-body .mobal-body-section-group:first-child {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    #editInstallerModal .modal-body .wrapper-modal-body .mobal-body-section-group:first-child .card-item-group,\r\n    .delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:first-child .card-item-group {\r\n        display: grid;\r\n        grid-template-columns: 0.5fr 1fr;\r\n        grid-column-gap: 10px;\r\n        text-align: start;\r\n    }\r\n\r\n    .delete-installer-details-modal .modal-body {\r\n        margin-bottom: 10px;\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .delete-installer-details-modal .modal-header-title-section svg {\r\n        width: 31px;\r\n        height: 31px;\r\n    }\r\n\r\n    .delete-installer-details-modal .modal-dialog .modal-content .modal-header-title-section .modal-header-title-item:nth-child(2) {\r\n        letter-spacing: 0.22px;\r\n    }\r\n\r\n    .delete-installer-details-modal .modal-dialog .modal-content .modal-header-title-section .modal-header-title-item:last-child {\r\n        font: normal normal normal 16px/19px Lato;\r\n        letter-spacing: 0.16px;\r\n        text-align: center;\r\n    }\r\n\r\n    .delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:last-child .form-group,\r\n    .delete-installer-details-modal .wrapper-modal-body .mobal-body-section-group:last-child .form-group textarea {\r\n        min-height: 150px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
